import { muiStyles } from 'utils/design';

export const useStyles = muiStyles((theme) => ({
  formControl: {
    width: 300,
    minWidth: '100%',
    maxWidth: '100%',
  },
  displayEmpty: {
    marginTop: theme.spacing(2),
  },
  reset: {
    position: 'absolute',
    right: '26px',
    fontSize: '0.8em',
    color: theme.palette.grey['600'],
    cursor: 'pointer',
    lineHeight: '32px',
  },
  tooltipIcon: {
    position: 'absolute',
    right: '26px',
  },
  label: {
    minWidth: 300,
  },
  groupedItem: {
    padding: theme.spacing(0, 2, 0, 4),
  },
}));
